import {useEffect, useRef, useState, StyleSheet} from 'react';

import cn from 'classnames';

/* DatePicker */
import DatePicker, {registerLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import '../../node_modules/react-datepicker/dist/react-datepicker-cssmodules.css';
// import '../../node_modules/react-datepicker/dist/react-datepicker-cssmodules.min.css';
// import '../../node_modules/react-datepicker/dist/react-datepicker.css';
// import '../../node_modules/react-datepicker/dist/react-datepicker.min.css';
import ko from 'date-fns/locale/ko'; // 한국어적용

/* bootstrap */
import 'bootstrap/dist/js/bootstrap.bundle.min';

/* CSS */
import '../assets/css/fontawesome.css';
import '../assets/css/custom.css'; /* 수정한 CSS */
import '../assets/css/animated.css';
import '../assets/css/owl.css';
import style from '../components/Modal/Modal.module.css';
// import '../../node_modules/intl-tel-input/build/css/intlTelInput.css'; /* 국가번호 CSS */

/* imgs */
import logo from '../assets/images/tnc_newlogo.jpeg';
import firstplace from '../assets/images/custom_1level_2x.png';
import icon_call from '../assets/images/custom_iconcall.png';
import medibusan from '../assets/images/custom_meditour_2x.png';
import US from '../assets/images/flag_us.png';
import RU from '../assets/images/flag_ru.png';
import CH from '../assets/images/flag_ch.png';
import VI from '../assets/images/flag_vi.png';
import instagram from '../assets/images/instagram.png';
import facebook from '../assets/images/facebook.png';

/* icon */
import {
    IoIosArrowForward,
    IoIosArrowDropright,
} from 'react-icons/io';

import {HiOutlineMinusSm} from 'react-icons/hi';

import {Link} from 'react-router-dom';
import Popup from '../components/Modal/Popup';
import moment from 'moment';
import {unAuthClient} from '../lib/axios';
import {useNavigate} from 'react-router-dom';
import _ from "lodash";
import KO from "../assets/images/flag_kr.png";
import UseRandomPhoneHook from "../lib/useRandomPhoneHook";

const JapanPage = () => {
    const [popup, setPopup] = useState(false);
    const [best, setBest] = useState([]);
    const [toggleIndex, setToggleIndex] = useState('');
    const [isLoading, SetLoading] = useState(true);
    const [videoSrc, setVideoSrc] = useState(668033560);
    const [selectedVideoIndex, setSelectedVideoIndex] = useState('0');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    //모바일 select박스 value에 따라 페이지 전환 때문에 navigate
    const navigate = useNavigate();
    const form = useRef();
    const [initialInputData, SetInitialInputData] = useState({
        user_name: '',
        phone: '',
        user_email: '',
        section: '병원예약', //need to default value
        detail_section: '상급·종합병원',
        message: '',
        user_count: 1,
        start: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        user_Room: 1,
        user_language: 'English',
    });
    const [isActiveLanguage, setIsActiveLanguage] = useState(false);
    const phoneNumber = UseRandomPhoneHook();

    const starSrc= [
        {'videoUUID': 668033560, 'title': '糖尿', 'kr': '당뇨'},
        {'videoUUID': 668045611, 'title': '神経性疾患', 'kr': '신경성 질환'},
        {'videoUUID': 776016314, 'title': '生理痛', 'kr': '생리통'},
        {'videoUUID': 765550250, 'title': '癌 1', 'kr': '암 1'},
        {'videoUUID': 765550424, 'title': '癌 2', 'kr': '암 2'},
        {'videoUUID': 765550586, 'title': '癌 3', 'kr': '암 3'},
        {'videoUUID': 776016580, 'title': '更年期', 'kr': '갱년기'},
        {'videoUUID': 694767290, 'title': '痴呆', 'kr': '치매'},
        {'videoUUID': 765557272, 'title': '女性老化', 'kr': '여성노화'},
        {'videoUUID': 776017203, 'title': '児童トリートメント', 'kr': '아동클리닉'},
        {'videoUUID': 776017073, 'title': 'ダイエット', 'kr': '다이어트'},
        {'videoUUID': 765549633, 'title': '体質医学', 'kr': '체질의학'},
        {'videoUUID': 776016822, 'title': '肥満', 'kr': '비만'},
        {'videoUUID': 765549371, 'title': 'はだえ', 'kr': '피부'},
        {'videoUUID': 765550080, 'title': '皮膚老化', 'kr': '피부노화'},
    ];

    const togglePopup = (el) => {
        setToggleIndex(el);
        setPopup(!popup);
        console.log(el);
    };


    const sendEmail = async (event) => {
        event.preventDefault();
        const option = {
            method: 'POST',
            mode: 'cors',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            data: initialInputData,
        };

        if (!_.isEmpty(initialInputData.user_name) && !_.isEmpty(initialInputData.user_email)) {
            try {
                await unAuthClient
                    .post('/sendmail', option);
                window.alert('success');
            } catch (err) {
                console.log('fetch error : ', err);
            } finally {
                window.location.reload();
            }
        } else {
            window.alert('Please enter required items ')
        }
    };

    const updateField = (e) => {
        if (e.target.name === 'section') {
            SetInitialInputData({
                user_name: '',
                phone: '',
                user_email: '',
                section: e.target.value,
                detail_section: '상급·종합병원',
                message: '',
                user_count: 1,
                start: moment(new Date()).format('YYYY-MM-DD HH:mm'),
                user_Room: 1,
                user_language: 'English',
            });
            setIsActiveLanguage(false);
        } else {
            SetInitialInputData({
                ...initialInputData,
                [e.target.name]: e.target.value,
            });
        }
    };

    const filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    };

    /* 호텔 */

    const addedDate = (data) => {
        SetInitialInputData({
            ...initialInputData,
            start: moment(data).format('YYYY-MM-DD HH:mm'),
        });
        console.log('test : ', data);
        console.log(initialInputData);
    };
    const endedDate = (data, e) => {
        SetInitialInputData({
            ...initialInputData,
            finish: moment(data).format('YYYY-MM-DD HH:mm'),
        });
        console.log('finish : ', data);
        console.log(initialInputData);
    };
    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    //베스트 3선 자세히 보기
    const best_pop = () => {
        const best_vener = [];

        if (best.length > 0) {
            best?.map((el, index) => {
                let file = el.FILE_POPUP;
                best_vener.push(
                    <div className='custom_bestitems' key={index}>
                        <ul>
                            {/* <!-- 힐링&웰니스 투어 --> */}
                            <li>
                                <img src={`/image/${file}`} alt={el.TITLE_ch}/>
                                {/* <img src={top_img} alt={el.TITLE_kr} /> */}
                            </li>
                            {/* <!-- img --> */}
                            <li>
                                <p className='custom_besttitle'>{el.TITLE_ch}</p>
                                <p className='custom_besttext'>{el.CONTENT_ch}</p>
                            </li>
                            {/* <!-- text --> */}
                            <li>
                                <button
                                    className='custom_morebtn'
                                    onClick={() => togglePopup(el)}
                                >
                                    詳しく見る
                                    {/*자세히 보기*/}
                                </button>
                            </li>
                        </ul>
                    </div>
                );
            });
        }
        return best_vener;
    };

    useEffect(() => {
        const fun = async () => {
            try {
                const res = await unAuthClient.get('/amendBest');
                setBest(res.data);
                SetLoading(false);
            } catch (e) {
                console.error(e);
            }
        };
        fun();
    }, []);

    const changeVideo = (event) => {
        setVideoSrc(event.target.name);
        setSelectedVideoIndex(event.target.id);
    };


    return (
        <>
            <header className='header_area header_sticky wow slideInDown'>
                {popup && (
                    <Popup
                        change='ko'
                        best={best}
                        index={toggleIndex}
                        togglePopup={togglePopup}
                    />
                )}
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <nav className='main-nav'>
                                {/* <!-- ***** Logo Start ***** --> */}
                                <a href='/JpPage' className='logo'>
                                    <img src={logo} alt="logo자리"/>
                                </a>
                                {/* <!-- ***** Logo End ***** --> */}

                                {/* <!-- ***** Menu Start ***** --> */}
                                <ul className='nav'>
                                    <li className='scroll-to-section'>
                                        <Link to='/'>
                                            <img src={US} alt='usa_flag'/>
                                        </Link>
                                    </li>
                                    {/* <!-- 영어 -->  */}

                                    <li className='scroll-to-section'>
                                        <Link to='/KrPage'>
                                            <img src={KO} alt='SouthKorea_flag'/>
                                        </Link>
                                    </li>
                                    {/* <!-- 한국어 --> */}

                                    <li className='scroll-to-section'>
                                        <Link to='/CnPage'>
                                            <img src={CH} alt='China_flag'/>
                                        </Link>
                                    </li>
                                    {/* <!-- 중국어 --> */}

                                    <li className='scroll-to-section'>
                                        <Link to='/RuPage'>
                                            <img src={RU} alt='Russia_flag'/>
                                        </Link>
                                    </li>
                                    {/* <!-- 러시아어 --> */}

                                    <li className='scroll-to-section'>
                                        <Link to='/VnPage'>
                                            <img src={VI} alt='Vietnam_flag'/>
                                        </Link>
                                    </li>
                                    {/* <!-- 베트남어 --> */}

                                    {/* 23-05-12 소셜미디어 링크 추가 */}
                                    <div className='socialMedia_link'>
                                        <li className='scroll-to-section'>
                                            <a href='https://www.instagram.com/star_doctor_in_busan_eng/' target={'_blank'}>
                                                <img src={instagram} alt='instagram link'/>
                                            </a>
                                        </li>
                                        <li className='scroll-to-section'>
                                            <a
                                                href='https://www.facebook.com/stardoctorinbusan.eng' target={'_blank'}>
                                                <img src={facebook} alt='facebook link'/>
                                            </a>
                                        </li>
                                    </div>
                                </ul>

                                <div className='nav_s'>
                                    <select
                                        key='/JpPage'
                                        defaultValue='/JpPage'
                                        onChange={(e) => {
                                            navigate(e.target.value);
                                        }}
                                    >
                                        <option className='scroll-to-section' value='/JpPage'>
                                            JP
                                        </option>
                                        {/* <!-- 일본어 --> */}

                                        <option className='scroll-to-section' value='/KrPage'>
                                            KR
                                        </option>
                                        {/* <!-- 한글 -->   */}
                                        <option className='scroll-to-section' value='/'>
                                            US
                                        </option>
                                        {/* <!-- 영어 --> */}
                                        <option className='scroll-to-section' value='/CnPage'>
                                            CN
                                        </option>
                                        {/* <!-- 중국어 --> */}
                                        <option className='scroll-to-section' value='/RuPage'>
                                            RU
                                        </option>
                                        {/* <!-- 러시아어 --> */}
                                        <option className='scroll-to-section' value='/VnPage'>
                                            VN
                                        </option>
                                        {/* <!-- 베트남어 --> */}
                                    </select>
                                    {/* 23-05-12 소셜미디어 링크 추가 */}
                                    <div className='socialMedia_link'>
                                        <li className='scroll-to-section'>
                                            <Link to='https://www.instagram.com/'>
                                                <img src={instagram} alt='instagram link'/>
                                            </Link>
                                        </li>
                                        <li className='scroll-to-section'>
                                            <Link to='https://www.facebook.com/'>
                                                <img src={facebook} alt='facebook link'/>
                                            </Link>
                                        </li>
                                    </div>
                                    {/* <a href='#contact'>
                    <div className='order-first-button'>login</div>
                  </a>
                  <div className='custom_setting'>
                    <IoMdSettings className='custom_settingicon' />
                  </div> */}
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
            {/* <!-- ***** Header Area End ***** --> */}

            {/* <!-- 대한민국 대표 의료관광도시 부산! --> */}
            <div
                className='main_banner wow fadeIn'
                id='top'
                data-wow-duration='1s'
                data-wow-delay='0.5s'
            >
                <div className='container custom_header'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='col-lg-12 align-self-center'>
                                <div
                                    className='left-content show-up header-text wow fadeInLeft'
                                    data-wow-duration='1s'
                                    data-wow-delay='1s'
                                >
                                    <div className='col-lg-12'>
                                        <h6 className='custom_title'>MEDICAL TECHNOLOGY</h6>
                                        <h2 className='custom_subtitle'>
                                            大韓民国を代表する医療観光都市、釜山！
                                        </h2>
                                        <p className='custom_content'>
                                            釜山は人口350万人の大韓民国第2の都市であり、最大の港湾都市です。四季折々の穏やかな気候と、山や海など天恵の観光資源と釜山花火大会、
                                            釜山花火大会や釜山国際映画祭など、多様な国際行事が開催される観光都市として、ロンリープラネットの「アジア最高旅行地1位（2018）」に選ばれるなど、全世界的な観光休養地としての基盤をしっかりと固めています。また、
                                            最高品質の医療サービスと最高水準の医療技術によって、イシア地域の代表的な医療観光地として「行きたい医療観光都市釜山」を作り出しており、観光客に最高の満足度を提供しています。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!--의료도시 1위 수상 --> */}
            <div id='about' className='about section'>

                <div className='row custom_row'>
                    <div className='col-lg-6 bg02img'>
                        {/* <!-- 왼쪽 bg img 들어감 --> */}
                    </div>
                </div>

                <div className='row custom_float'>
                    <div
                        className='col-lg-12 align-self-center wow fadeInRight'
                        data-wow-duration='1s'
                        data-wow-delay='0.5s'
                    >
                        <div className='section-heading'>
                            {/* <!-- 1숫자 --> */}
                            <div className='custom_num1img'>
                                <img src={firstplace} alt='의료도시 부문1위'/>
                            </div>
                        </div>
                        <h2 className='custom_subtitle'>
                            大韓民国国家ブランド
                            <br/>
                            「医療都市部門1位」受賞
                        </h2>
                        <p className='custom_text'>
                            釜山は医療観光産業の集中育成を通じて、北東アジアの医療観光中心都市を目指しています。また、韓国初の重粒子加速器（2023年導入）ロボット手術センターなど、世界水準の医療インフラを整備しています。
                            そして、 5,000余りの優れた専門人材を有する医療機関と、西面メディカルストリートなどに集積された医療観光クラスターを基に、
                            整形外科、皮膚科、歯科から脳、心臓、腫瘍治療など重症疾患まで、幅広い患者群に対して高品質の医療サービスを提供しています。
                        </p>
                    </div>
                </div>
            </div>

            {/* 부산 메디컬 센터, 컨시어지 서비스 */}
            <div id='services' className='services section'>
                <div className='container custom_service'>
                    <div className='row col-lg-12'>
                        <div className='custom_info'>
                            <div
                                className='section-heading wow fadeInDown custom_info01 custom_short01'
                                data-wow-duration='1s'
                                data-wow-delay='0.5s'
                            >
                                {/* <img src={picture01} alt='부산메디컬센터' /> */}
                                <iframe
                                    src='https://player.vimeo.com/video/787477437?autoplay=1&loop=1&autopause=0&background=1'
                                    //src='https://player.vimeo.com/video/787477437?h=c382c2818a&amp;badge=0&amp;autoplay=1&loop=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479?'
                                    allow='autoplay; fullscreen; picture-in-picture'
                                    title='쇼츠 동아대학교병원'
                                ></iframe>
                                <script src='https://player.vimeo.com/api/player.js'></script>
                            </div>

                            <div
                                className='custom_info02 wow fadeInDown'
                                data-wow-duration='1s'
                                data-wow-delay='0.5s'
                            >
                                <h4 className='custom_info_title'>釜山メディカルセンターは</h4>
                                <h6 className='custom_info_subtext'>
                                    メディカルセンターは釜山を訪れる医療観光客のために空港送迎車からホテル予約、通訳サービス、ウェルネス観光ツアーパッケージの紹介まで、さまざまな便宜サービスを提供しています。これにより、より快適で安全に釜山医療観光をお楽しみいただけるようサポートする医療観光サービスプラットフォームです。
                                    詳細なサービスに関するお問い合わせや病院の予約については、メッセンジャーやメール、電話でご相談いただけます。
                                </h6>
                            </div>
                        </div>
                    </div>
                    {/* <!-- row 1 end --> */}
                    {/* 테블릿 싸이즈 - CSS 1739 */}
                    <div className='row col-lg-12'>
                        <div className='custom_info custom_info_s'>
                            <div
                                className='custom_info02 wow fadeInDown'
                                data-wow-duration='1s'
                                data-wow-delay='0.5s'
                            >
                                <h4 className='custom_info_title'>コンシェルジュ・サービス</h4>
                                <h6 className='custom_info_subtext'>
                                    メディカルセンター事業は、釜山広域市の予算で釜山圏医療産業協議会が開発し、釜山TNCが運営する事業で、医療観光客の不便を軽減するためのコンシェルジュ専門プラットフォームです。お客様に合わせたさまざまなコンシェルジュサービスを提供し、釜山を訪れる外国人医療観光客に対して、より質の高いサービスを提供します。
                                </h6>
                            </div>
                            <div
                                className='section-heading wow fadeInDown custom_info01 custom_short02'
                                data-wow-duration='1s'
                                data-wow-delay='0.5s'
                            >
                                {/* <img src={picture02} alt='부산메디컬센터' /> */}
                                <iframe
                                    //src='https://player.vimeo.com/video/787477407?h=2bbea0f96b&amp;badge=0&amp;autoplay=1&loop=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                                    src='https://player.vimeo.com/video/787477407??autoplay=1&loop=1&amp;&autopause=0&background=1'
                                    allow='autoplay; fullscreen; picture-in-picture'
                                    title='쇼츠 메디컬센터 김해'
                                ></iframe>
                                <script src='https://player.vimeo.com/api/player.js'></script>
                            </div>
                        </div>
                    </div>
                    {/* <!-- row 2 end --> */}
                </div>
            </div>

            {/* 의료기관, 호텔 소개 바로가기 */}
            <div id='banners' className='banners'>
                <div className='custom_bannerdiv'>
                    <div className='custom_medicalbusanlink'>
                        <img src={medibusan} alt='메디컬부산'/>
                    </div>
                    <div className='custom_banners'>
                        <div className='banner_wrap'>
                            <div className='custom_banner01'>
                                {/*<p>의료기관 소개</p>*/}
                                <p>医療機関の紹介</p>
                                <a href=''>
                                    <button
                                        onClick={() =>
                                            window.open(
                                                'https://www.bsmeditour.go.kr/medicalInstitution.do',
                                                '_blank'
                                            )
                                        }
                                    >
                                        {/*바로가기*/}
                                        ショートカット <IoIosArrowForward className='custom_icon'/>
                                    </button>
                                </a>
                            </div>
                            <div className='custom_banner02'>
                                {/*<p>호텔 소개</p>*/}
                                <p>ホテルの紹介 </p>
                                <a href='#'>
                                    <button
                                        onClick={() =>
                                            window.open(
                                                'https://www.bsmeditour.go.kr/AboutHotel.do',
                                                '_blank'
                                            )
                                        }
                                    >
                                        {/*바로가기*/}
                                        ショートカット <IoIosArrowForward className='custom_icon'/>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 클리닉 비디오, 리스트 */}
            <div id='clinic_videos' className='clinic_videos section'>
                <div className='container'>
                    <div className='custom_video_list_wrap'>
                        <div className='clinic_video'>
                            <iframe
                                src={`https://player.vimeo.com/video/${videoSrc}`}

                                allow='autoplay; fullscreen'
                                title='custom_video'
                            ></iframe>
                        </div>
                        <div className='videoList'>
                            {starSrc.map((video, index) => {
                                return (<button
                                    className='videoList_btn'
                                    style={{
                                        backgroundColor: selectedVideoIndex === index.toString() ? '#274fd5' : '',
                                        color: selectedVideoIndex === index.toString() ? '#fff' : '',
                                    }}
                                    id={index.toString()}
                                    name={video.videoUUID}
                                    onClick={(e) => {
                                        changeVideo(e);
                                    }}
                                >
                                    {/* 비디오 타이틀 */}
                                    {video.title}
                                    <IoIosArrowDropright className='icon_arrow'/>
                                </button>)
                            })}
                            <button className='videoList_btn'>라인맞추기용</button>
                        </div>

                    </div>
                </div>
            </div>

            {/* 예약 form */}
            <div id='new_contact' className='new_contact section'>
                <div className='container container_s'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='naccs'>
                                <div className='grid custom_accodian'>
                                    <div className='row custom_contact'>
                                        <div className='col-lg-3 custom_call'>
                                            {/* <!-- 전화 상담 --> */}
                                            <ul>
                                                <li>
                                                    <img src={icon_call} alt='문의전화'/>
                                                </li>
                                                {/* <!-- icon img --> */}
                                                <li>
                                                    <p className='custom_ask'>
                                                        ご不明な点がございましたら、
                                                        <br/>
                                                        親切にご相談いたします。
                                                </p>
                                            </li>
                                            <li>
                                                <p className='custom_servicenumber'>
                                                    +82 70-8874-9334<br/>
                                                    +82 10-2127-9334
                                                </p>
                                            </li>
                                        </ul>
                                        {/*전화 상담하기*/}
                                        <a href={`tel:${phoneNumber}`}>
                                            <button className='custom_call_btn'>電話相談</button>
                                        </a>
                                    </div>
                                    <div
                                        className='col-lg-8 custom_accordion accordion nacc'
                                            id='accordionExample'
                                        >
                                            <div className='accordion-item'>
                                                <h2 className='accordion-header' id='headingOne'>
                                                    <button
                                                        className='accordion-button'
                                                        type='button'
                                                        name='section'
                                                        onClick={updateField}
                                                        value='병원예약'
                                                        data-bs-toggle='collapse'
                                                        data-bs-target='#collapseOne'
                                                        aria-expanded='true'
                                                        aria-controls='collapseOne'
                                                    >
                                                        病院予約
                                                    </button>
                                                </h2>
                                                <div
                                                    id='collapseOne'
                                                    className='accordion-collapse collapse show'
                                                    aria-labelledby='headingOne'
                                                    data-bs-parent='#accordionExample'
                                                >
                                                    <div className='accordion-body custom_accordion-body'>
                                                        <form
                                                            className='custom_form'
                                                            ref={form}
                                                            onSubmit={sendEmail}
                                                        >
                                                            <div className='custom_name divs'>
                                                                <label>お名前</label>
                                                                <input
                                                                    type='text'
                                                                    name='user_name'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_number divs'>
                                                                <label>連絡先</label>
                                                                <input
                                                                    id='phone'
                                                                    type='tel'
                                                                    name='phone'
                                                                    onChange={updateField}
                                                                />
                                                                {/* <input type="submit" className="btn" value="Verify" /> */}
                                                            </div>
                                                            <div className='custom_email divs'>
                                                                <label>メール</label>
                                                                <input
                                                                    type='email'
                                                                    name='user_email'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_selection divs'>
                                                                <label>診療科目</label>
                                                                <select
                                                                    onChange={updateField}
                                                                    name='detail_section'
                                                                >
                                                                    <option value={'상급·종합병원'}>上級・総合病院</option>
                                                                    <option value={'종합검진'}>総合検診</option>
                                                                    <option value={'정형외과'}>整形外科</option>
                                                                    <option value={'성형외과'}>整形外科</option>
                                                                    <option value={'산부인과'}>産婦人科</option>
                                                                    <option value={'피부과'}>皮膚科</option>
                                                                    <option value={'치과'}>歯科</option>
                                                                    <option value={'안과'}>眼科</option>
                                                                    <option value={'한방'}>韓方</option>
                                                                    <option value={'기타'}>その他</option>
                                                                </select>
                                                            </div>
                                                            <div className='custom_language divs'>
                                                                <label>言語</label>
                                                                <div className='custom_radioselect'>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='English'
                                                                            defaultChecked
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>英語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Russian'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>ロシア語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Chinese'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>中国語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Vietnamese'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>ベトナム語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Japanes'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>日本語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='etc'
                                                                            onClick={() => setIsActiveLanguage(true)}
                                                                        />
                                                                        {isActiveLanguage ?
                                                                            <input className='language_div'
                                                                                   type='text'
                                                                                   placeholder=''
                                                                                   name='user_language'
                                                                                   onChange={updateField}/> :
                                                                            <p>その他</p>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='custom_contentbox divs'>
                                                                <label>内容</label>
                                                                <textarea
                                                                    name='message'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <input
                                                                type='submit'
                                                                value='送信'
                                                                className='custom_sendbtn'
                                                            />
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* 병원 예약 */}
                                            <div className='accordion-item'>
                                                <h2 className='accordion-header' id='headingTwo'>
                                                    <button
                                                        className='accordion-button collapsed'
                                                        name='section'
                                                        onClick={updateField}
                                                        value='컨시어지'
                                                        type='button'
                                                        data-bs-toggle='collapse'
                                                        data-bs-target='#collapseTwo'
                                                        aria-expanded='false'
                                                        aria-controls='collapseTwo'
                                                    >
                                                        {/* <img src={reserve02} alt="Concierge" /> */}
                                                        コンシェルジュ
                                                    </button>
                                                </h2>
                                                <div
                                                    id='collapseTwo'
                                                    className='accordion-collapse collapse'
                                                    aria-labelledby='headingTwo'
                                                    data-bs-parent='#accordionExample'
                                                >
                                                    <div className='accordion-body custom_accordion-body'>
                                                        <form
                                                            className='custom_form'
                                                            ref={form}
                                                            onSubmit={sendEmail}
                                                        >
                                                            <div className='custom_name divs'>
                                                                <label>お名前</label>
                                                                <input
                                                                    type='text'
                                                                    name='user_name'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_number divs'>
                                                                <label>連絡先</label>
                                                                <input
                                                                    id='phone'
                                                                    type='tel'
                                                                    name='phone'
                                                                    onChange={updateField}
                                                                />
                                                                {/* <input type="submit" className="btn" value="Verify" /> */}
                                                            </div>
                                                            <div className='custom_email divs'>
                                                                <label>メール</label>
                                                                <input
                                                                    type='email'
                                                                    name='user_email'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_selection divs'>
                                                                <label>診療科目</label>
                                                                <select
                                                                    onChange={updateField}
                                                                    name='detail_section'
                                                                >
                                                                    <option value={'상급·종합병원'}>上級・総合病院</option>
                                                                    <option value={'종합검진'}>総合検診</option>
                                                                    <option value={'정형외과'}>整形外科</option>
                                                                    <option value={'성형외과'}>整形外科</option>
                                                                    <option value={'산부인과'}>産婦人科</option>
                                                                    <option value={'피부과'}>皮膚科</option>
                                                                    <option value={'치과'}>歯科</option>
                                                                    <option value={'안과'}>眼科</option>
                                                                    <option value={'한방'}>韓方</option>
                                                                    <option value={'기타'}>その他</option>
                                                                </select>
                                                            </div>
                                                            <div className='custom_language divs'>
                                                                <label>言語</label>
                                                                <div className='custom_radioselect'>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='English'
                                                                            defaultChecked
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>英語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Russian'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>ロシア語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Chinese'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>中国語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Vietnamese'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>ベトナム語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Japanes'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>日本語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='etc'
                                                                            onClick={() => setIsActiveLanguage(true)}
                                                                        />
                                                                        {isActiveLanguage ?
                                                                            <input className='language_div'
                                                                                   type='text'
                                                                                   placeholder=''
                                                                                   name='user_language'
                                                                                   onChange={updateField}/> :
                                                                            <p>その他</p>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={cn(
                                                                    style.concierge_div,
                                                                    style.form_div
                                                                )}
                                                            >
                                                                <div className={style.dateset}>
                                                                    <p>日付選択</p>
                                                                    <DatePicker
                                                                        locale={ko}
                                                                        timeCaption='시간'
                                                                        name='start'
                                                                        selected={startDate}
                                                                        onChange={(data, e) => {
                                                                            setStartDate(data);
                                                                            addedDate(data, e);
                                                                        }}
                                                                        showTimeSelect
                                                                        filterTime={filterPassedTime}
                                                                        dateFormat='yyyy-MM-dd, h:mm aa'
                                                                    />
                                                                </div>
                                                                <div className={style.memberset}>
                                                                    <p>人数</p>
                                                                    <select
                                                                        onChange={updateField}
                                                                        name='user_count'
                                                                    >
                                                                        <option>1</option>
                                                                        <option>2</option>
                                                                        <option>3</option>
                                                                        <option>4</option>
                                                                        <option>5</option>
                                                                        <option>6</option>
                                                                        <option>7</option>
                                                                        <option>8</option>
                                                                        <option>9</option>
                                                                        <option>10</option>
                                                                    </select>
                                                                </div>
                                                                <div className={style.destinationset}>
                                                                    <p>出発/到着</p>
                                                                    <input
                                                                        type='text'
                                                                        placeholder=''
                                                                        name='destination'
                                                                        onChange={updateField}
                                                                    />
                                                                </div>
                                                                {/* <button className={style.carbtn}>차량예약</button> */}
                                                            </div>
                                                            <input
                                                                type='submit'
                                                                value='送信'
                                                                className='custom_sendbtn'
                                                            />
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='accordion-item'>
                                                <h2 className='accordion-header' id='headingThree'>
                                                    <button
                                                        className='accordion-button collapsed'
                                                        name='section'
                                                        onClick={updateField}
                                                        value='호텔예약'
                                                        type='button'
                                                        data-bs-toggle='collapse'
                                                        data-bs-target='#collapseThree'
                                                        aria-expanded='false'
                                                        aria-controls='collapseThree'
                                                    >
                                                        ホテル予約
                                                    </button>
                                                </h2>
                                                <div
                                                    id='collapseThree'
                                                    className='accordion-collapse collapse'
                                                    aria-labelledby='headingThree'
                                                    data-bs-parent='#accordionExample'
                                                >
                                                    <div className='accordion-body custom_accordion-body'>
                                                        <form
                                                            className='custom_form'
                                                            ref={form}
                                                            onSubmit={sendEmail}
                                                        >
                                                            <div className='custom_name divs'>
                                                                <label>お名前</label>
                                                                <input
                                                                    type='text'
                                                                    name='user_name'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_number divs'>
                                                                <label>連絡先</label>
                                                                <input
                                                                    id='phone'
                                                                    type='tel'
                                                                    name='phone'
                                                                    onChange={updateField}
                                                                />
                                                                {/* <input type="submit" className="btn" value="Verify" /> */}
                                                            </div>
                                                            <div className='custom_email divs'>
                                                                <label>メール</label>
                                                                <input
                                                                    type='email'
                                                                    name='user_email'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_selection divs'>
                                                                <label>診療科目</label>
                                                                <select
                                                                    onChange={updateField}
                                                                    name='detail_section'
                                                                >
                                                                    <option value={'상급·종합병원'}>上級・総合病院</option>
                                                                    <option value={'종합검진'}>総合検診</option>
                                                                    <option value={'정형외과'}>整形外科</option>
                                                                    <option value={'성형외과'}>整形外科</option>
                                                                    <option value={'산부인과'}>産婦人科</option>
                                                                    <option value={'피부과'}>皮膚科</option>
                                                                    <option value={'치과'}>歯科</option>
                                                                    <option value={'안과'}>眼科</option>
                                                                    <option value={'한방'}>韓方</option>
                                                                    <option value={'기타'}>その他</option>
                                                                </select>
                                                            </div>
                                                            <div className='custom_hotel divs'>
                                                                <label>ホテル名</label>
                                                                <input
                                                                    type='hotel'
                                                                    name='hotel'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_language divs'>
                                                                <label>言語</label>
                                                                <div className='custom_radioselect'>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='English'
                                                                            defaultChecked
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>英語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Russian'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>ロシア語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Chinese'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>中国語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Vietnamese'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>ベトナム語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='Japanes'
                                                                            onChange={updateField}
                                                                            onClick={() => setIsActiveLanguage(false)}
                                                                        />
                                                                        <p>日本語</p>
                                                                    </div>
                                                                    <div className='custom_langua'>
                                                                        <input
                                                                            type='radio'
                                                                            name='user_language'
                                                                            value='etc'
                                                                            onClick={() => setIsActiveLanguage(true)}
                                                                        />
                                                                        {isActiveLanguage ?
                                                                            <input className='language_div'
                                                                                   type='text'
                                                                                   placeholder=''
                                                                                   name='user_language'
                                                                                   onChange={updateField}/> :
                                                                            <p>その他</p>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={cn(style.hotel_div, style.form_div)}
                                                            >
                                                                <div
                                                                    className={cn(
                                                                        style.dateset,
                                                                        style.hotel_dateset
                                                                    )}
                                                                >
                                                                    <p>日付選択</p>
                                                                    <div className={style.datepickeralign}>
                                                                        <DatePicker
                                                                            selected={startDate}
                                                                            onChange={(date) => {
                                                                                setStartDate(date);
                                                                                addedDate(date);
                                                                            }}
                                                                            selectsStart
                                                                            startDate={startDate}
                                                                            endDate={endDate}
                                                                            minDate={new Date()}
                                                                            name='start'
                                                                            locale={ko}
                                                                            dateFormat='yyyy-MM-dd'
                                                                        />
                                                                        <HiOutlineMinusSm
                                                                            className={style.icon_line}
                                                                        />
                                                                        <DatePicker
                                                                            name='finish'
                                                                            selected={endDate}
                                                                            onChange={(date) => {
                                                                                setEndDate(date);
                                                                                endedDate(date);
                                                                            }}
                                                                            selectsEnd
                                                                            startDate={startDate}
                                                                            endDate={endDate}
                                                                            minDate={startDate}
                                                                            locale={ko}
                                                                            dateFormat='yyyy-MM-dd'
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className={style.memberset}>
                                                                    <p>人数</p>
                                                                    <select
                                                                        onChange={updateField}
                                                                        name='user_count'
                                                                    >
                                                                        <option>1</option>
                                                                        <option>2</option>
                                                                        <option>3</option>
                                                                        <option>4</option>
                                                                        <option>5</option>
                                                                        <option>6</option>
                                                                        <option>7</option>
                                                                        <option>8</option>
                                                                        <option>9</option>
                                                                        <option>10</option>
                                                                    </select>
                                                                </div>
                                                                <div className={style.hotelroom}>
                                                                    <p>客室</p>
                                                                    <select
                                                                        onChange={updateField}
                                                                        name='user_Room'
                                                                    >
                                                                        <option>1</option>
                                                                        <option>2</option>
                                                                        <option>3</option>
                                                                        <option>4</option>
                                                                        <option>5</option>
                                                                    </select>
                                                                </div>
                                                                {/* <button className={style.carbtn}>차량예약</button> */}
                                                            </div>
                                                            {/* .hotel_div end */}
                                                            <input
                                                                type='submit'
                                                                value='送信'
                                                                className='custom_sendbtn'
                                                            />
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='accordion-item'>
                                                <h2 className='accordion-header' id='headingFour'>
                                                    <button
                                                        className='accordion-button collapsed'
                                                        name='section'
                                                        onClick={updateField}
                                                        value='통역예약'
                                                        type='button'
                                                        data-bs-toggle='collapse'
                                                        data-bs-target='#collapseFour'
                                                        aria-expanded='false'
                                                        aria-controls='collapseFour'
                                                    >
                                                        通訳予約
                                                    </button>
                                                </h2>
                                                <div
                                                    id='collapseFour'
                                                    className='accordion-collapse collapse'
                                                    aria-labelledby='headingFour'
                                                    data-bs-parent='#accordionExample'
                                                >
                                                    <div className='accordion-body custom_accordion-body'>
                                                        <form
                                                            className='custom_form'
                                                            ref={form}
                                                            onSubmit={sendEmail}
                                                        >
                                                            <div className='custom_name divs'>
                                                                <label>お名前</label>
                                                                <input
                                                                    type='text'
                                                                    name='user_name'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_number divs'>
                                                                <label>連絡先</label>
                                                                <input
                                                                    id='phone'
                                                                    type='tel'
                                                                    name='phone'
                                                                    onChange={updateField}
                                                                />
                                                                {/* <input type="submit" className="btn" value="Verify" /> */}
                                                            </div>
                                                            <div className='custom_email divs'>
                                                                <label>メール</label>
                                                                <input
                                                                    type='email'
                                                                    name='user_email'
                                                                    onChange={updateField}
                                                                />
                                                            </div>
                                                            <div className='custom_selection divs'>
                                                                <label>診療科目</label>
                                                                <select
                                                                    onChange={updateField}
                                                                    name='detail_section'
                                                                >
                                                                    <option value={'상급·종합병원'}>上級・総合病院</option>
                                                                    <option value={'종합검진'}>総合検診</option>
                                                                    <option value={'정형외과'}>整形外科</option>
                                                                    <option value={'성형외과'}>整形外科</option>
                                                                    <option value={'산부인과'}>産婦人科</option>
                                                                    <option value={'피부과'}>皮膚科</option>
                                                                    <option value={'치과'}>歯科</option>
                                                                    <option value={'안과'}>眼科</option>
                                                                    <option value={'한방'}>韓方</option>
                                                                    <option value={'기타'}>その他</option>
                                                                </select>
                                                            </div>
                                                            <div
                                                                className={cn(
                                                                    style.translate_div,
                                                                    style.form_div
                                                                )}
                                                            >
                                                                <div className={style.langset}>
                                                                    <p>言語選択</p>
                                                                    <select
                                                                        onChange={updateField}
                                                                        name='user_language'
                                                                    >
                                                                        <option value='English' selected>英語</option>
                                                                        <option value='Chinese'>中国語</option>
                                                                        <option value='Russian'>ロシア語</option>
                                                                        <option value='Vietnamese'>ベトナム語</option>
                                                                        <option value='Japanes'>日本語</option>
                                                                    </select>
                                                                </div>
                                                                <div className={style.dateset}>
                                                                    <p>日付選択</p>
                                                                    <DatePicker
                                                                        locale={ko}
                                                                        selected={startDate}
                                                                        onChange={(data, e) => {
                                                                            setStartDate(data);
                                                                            addedDate(data, e);
                                                                        }}
                                                                        showTimeSelect
                                                                        filterTime={filterPassedTime}
                                                                        timeCaption='시간'
                                                                        dateFormat='yyyy-MM-dd h:mm aa'
                                                                    />
                                                                </div>
                                                                <div className={style.destinationset}>
                                                                    <p>出発/到着</p>
                                                                    <input
                                                                        type='text'
                                                                        placeholder=''
                                                                        name='destination'
                                                                        onChange={updateField}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <input
                                                                type='submit'
                                                                value='送信'
                                                                className='custom_sendbtn'
                                                            />
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* accordion end */}
                                    </div>
                                    {/*  <!-- .row end --> */}
                                </div>
                                {/* <!-- .grid end --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* VR 영상 23-05-12 위치 이동 */}
            <div id='vr_videos' className='col-lg-12 vr_videos'>
                <div className='container'>
                    <div className='vr_video_wrap'>
                        <ul className='vr_video_list'>
                            <li>
                                <iframe
                                    src='https://player.vimeo.com/video/783849715?h=28004e4a8a&badge=0&autopause=0&player_id=0&app_id=58479/embed'
                                    allow='autoplay; fullscreen'
                                    title='custom_video'
                                ></iframe>
                            </li>
                            <li>
                                <iframe
                                    src={'https://player.vimeo.com/video/779141748?h=09df3f454e'}
                                    allow='autoplay; fullscreen'
                                    title='custom_video'
                                ></iframe>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* BEST 3 Collection */}
            <div id='board' className='board col-lg-12'>
                <div className='container custom_board'>
                    <div className='section-heading'>
                        <h4>BEST 3 Collection</h4>
                    </div>
                    {isLoading ? null : best_pop()}
                </div>
                {/* .container .custom_board end*/}
            </div>

            <div className='footer'>
                <div className='custom_footcontainer'>
                    <div className='row'>
                        <div className='col-lg-12 custom_footer'>
                            <h5>(株)釜山ティーエヌシー</h5>
                            <p className='custom_footerp'>
                                釜山市東区忠壮大路206釜山港国際旅客ターミナル3階3B08
                                (釜山メディツアーセンター &amp; クルーズラウンジ)
                            </p>
                            <ul className='custom_footerul'>
                                <li>
                                    <span>T</span> 070-8874-9334
                                </li>
                                <li>
                                    <span>F</span> 051-462-9334
                                </li>
                                <li>
                                    <span>E</span> busancruiselounge@gmail.com
                                </li>
                            </ul>
                            <p>Copyright 2023. BUSAN TNC All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default JapanPage;